import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class SectionService {
    static getSections(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`sections?filter=${qs}`, pageNumber));
    }
    static fetchSection(oid) {
        return lastValueFrom(BaseService.get(`sections/${oid}`));
    }
    static saveSection(dto) {
        return lastValueFrom(BaseService.save(`sections`, dto));
    }
    static deleteSection(oid) {
        return lastValueFrom(BaseService.delete(`sections/${oid}`));
    }
    static searchSectionCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`sections-search-dropdown/${selfId}?search=${qs}`));
    }
    static getSectionsDTO(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.get(`sections-dto?filter=${qs}`));
    }
}
